import type { DetailRow, PaneData } from '../../shared/contracts';
import { detailRowsOf } from '../lib/pane-rows';
import { PaneFrame } from './PaneFrame';
import { EmptyRow } from './States';

/** Agenda/board: rows with an HTML body open it in a modal; bodiless rows are inert. */
export function AgendaCard({ pane, onOpslag, eyebrow }: { pane: PaneData; onOpslag?: (row: DetailRow) => void; eyebrow?: string }) {
  const rows = detailRowsOf(pane);
  return (
    <PaneFrame title={pane.title} source={pane.source} eyebrow={eyebrow} periodLabel={pane.periodLabel}>
      <ul className="space-y-1">
        {rows.map((row, i) => {
          const clickable = Boolean(row.html);
          return (
          <li
            key={row.id}
            className={`-mx-2 flex gap-3 rounded-lg px-2 py-2 transition-colors ${clickable ? 'cursor-pointer hover:bg-brand-primary/5' : ''}`}
            onClick={clickable ? () => onOpslag?.(row) : undefined}
          >
            <div className="flex flex-col items-center pt-1">
              <span className="h-2 w-2 rounded-full bg-brand-accent" />
              {i < rows.length - 1 && <span className="mt-1 w-px flex-1 bg-brand-primary/10" />}
            </div>
            <div className="flex-1">
              <div className="text-[11px] font-medium uppercase tracking-wide text-brand-accent">{row.meta}</div>
              <div className="line-clamp-2 text-sm font-medium text-brand-dark">{row.title}</div>
              {row.subtitle && <div className="line-clamp-1 text-xs text-brand-dark/50">{row.subtitle}</div>}
            </div>
            {row.value && <span className="h-fit rounded-full bg-brand-primary/5 px-2 py-0.5 text-[10px] text-brand-dark/60">{row.value}</span>}
          </li>
          );
        })}
        {rows.length === 0 && <EmptyRow label="Ingen aftaler." />}
      </ul>
    </PaneFrame>
  );
}
